import React from 'react'

import { List } from '@fourthwall/components'

import { ConnectedSiteListItem } from '../ConnectedSitesListItem/ConnectedSitesListItem'
import type { ConnectedSite } from '../ConnectedSitesListItem/ConnectedSitesListItem.types'

export type ConnectedSitesListProps = {
  items: ConnectedSite[]
}

export const ConnectedSitesList = ({ items }: ConnectedSitesListProps) => (
  <List
    data={items}
    topBorder={false}
    renderItem={(connectedSite: ConnectedSite) => (
      <ConnectedSiteListItem connectedSite={connectedSite} />
    )}
  />
)
